import { Component } from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';

@Component({
  selector: 'app-equipment',
  standalone: false,
  templateUrl: './equipment.component.html',
  styleUrl: './equipment.component.css',
  animations: [
    trigger('expandCollapse', [
      state('expanded', style({
        height: '*',
        opacity: 1,
        padding: '*'
      })),
      state('collapsed', style({
        height: '0px',
        opacity: 0,
        padding: '0'
      })),
      transition('expanded <=> collapsed', [
        animate('500ms ease')
      ]),
    ])
  ]
})
export class EquipmentComponent {
  items = [
    { name: 'Jane Smith', est: '14h', worked: '12h', billable: '$870.00' },
    { name: 'John Doe', est: '10h', worked: '09h', billable: '$870.00' },
    { name: 'Alice Johnson', est: '08h', worked: '08h', billable: '$870.00' },
    { name: 'Chris Walker', est: '11h', worked: '10h', billable: '$870.00' },
    { name: 'Nina Patel', est: '13h', worked: '11h', billable: '$870.00' },
  ];
  expandedIndex = -1; // none expanded initially
  toggle(index: number) {
    this.expandedIndex = this.expandedIndex === index ? -1 : index;
  }
}
